export default __webpack_public_path__ + "static/media/black-back.377a1eec.svg";